// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Dn6--PopoverController--PopoverController{display:inline-flex;align-items:stretch}.Dn6--PopoverController--PopoverController>:first-child{flex-grow:1}.H3Q--PopoverController--hide{visibility:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PopoverController": "Dn6--PopoverController--PopoverController",
	"hide": "H3Q--PopoverController--hide"
};
module.exports = ___CSS_LOADER_EXPORT___;
